import React, { useCallback, useContext, useEffect, useState } from "react";
import "./createMediaRequest.scss";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Checkbox,
  Divider,
  List,
  ListItem,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import {
  CREATE_MEDIA,
  AUDIO_CONTENT_KIND_MAPPING,
  NAMESPACE_TO_ID_TYPE_MAPPING,
  VIDEO_CODEC,
} from "../../../constants/CreateMediaRequest";
import { getFrameRate, getEditRate, getAspectRatio } from "./util";
import { MediaRequestContext } from "../../../context/MediaRequestContext";
import { ConfigContext } from "../../../security/ConfigContext";

const Video = ({ manifestation, assetTitle, entityType, idType }) => {
  const [expanded, setExpanded] = useState(false);
  const {
    selectedFiles,
    handleSelectFile,
    _setIdAccordionExpanded,
    validAssets,
    idAccordionExpanded,
    titleAccordionExpanded,
    _setTitleAccordionExpanded,
    renamedFilename,
    transferRegion,
    _setSelectedFiles,
    getSourceId,
    getSourceIdNamespace,
  } = useContext(MediaRequestContext);
  const config = useContext(ConfigContext);
  const editRate = getEditRate(manifestation.editRate);
  const { environment } = config[0].app;
  let totalVideosAvailable = 0;

  manifestation?.containers?.forEach((container) => {
    manifestation?.components?.forEach((component) => {
      if (
        component.componentType?.includes("video") &&
        component.trackReference?.containerId === container.containerId
      ) {
        totalVideosAvailable += 1;
      }
    });
  });

  const handleSelectAllFile = (e) => {
    let selectedFileDetails = { ...selectedFiles };
    manifestation.containers?.forEach((container) => {
      if (container.path) {
        const pathSplit = container.path?.split(".");
        const format = pathSplit[pathSplit.length - 1];
        const file = `${container.containerId}.${format}`;
        manifestation.components?.forEach((component) => {
          const video = component.componentType?.includes("video") && component.trackReference?.containerId === container.containerId;
          if (video) {
            if (e.target.checked) {
              if (file in selectedFileDetails) {
                selectedFileDetails[file]["isChecked"] = true;
                if (transferRegion[manifestation?.id] === "GCSSNY-MX_Content App") {
                  selectedFileDetails[file]["sourceUri"] = container.path;
                  selectedFileDetails[file]["containerId"] = container.containerId;
                }
              }
              else {
                const alternateId = getSourceId(manifestation);
                const idNamespace = getSourceIdNamespace(manifestation);
                const manifestationId = manifestation?.id;
                let renameString = "";
                selectedFileDetails = {
                  ...selectedFileDetails,
                  [file]: {
                    id: alternateId,
                    namespace: idNamespace,
                    idType: NAMESPACE_TO_ID_TYPE_MAPPING[idNamespace],
                    fileType: "Video",
                    title: assetTitle,
                    transfer: transferRegion[manifestationId],
                    renamePrefix: renameString,
                    renamedFilename: renamedFilename[file],
                    ...(transferRegion[manifestationId] === "GCSSNY-MX_Content App" && {
                      sourceUri: container.path,
                      containerId: container.containerId,
                    }),
                    isChecked: true,
                    isMamProxy: false,
                  },
                };
              }
            } else {
              selectedFileDetails[file]["isChecked"] = false;
            }
            _setSelectedFiles(selectedFileDetails);
          }
        });
      }
    });
  };
  
  const areAllCheckboxesChecked = useCallback(() => {
    let existingVideo = {};
    manifestation.containers?.forEach((container) => {
      if (container.path) {
        const pathSplit = container.path?.split(".");
        const format = pathSplit[pathSplit.length - 1];
        const file = `${container.containerId}.${format}`;
        manifestation.components?.forEach((component) => {
          const video = component.componentType?.includes("video") && component.trackReference?.containerId === container.containerId ;
          if (video) {
            existingVideo[file] = true;
          }
        });
      }
    });
    for (const fileName in existingVideo) {
      if (!selectedFiles[fileName]?.isChecked) {
        return false;
      }
    }
    return true;
  }, [manifestation.components, manifestation.containers, selectedFiles]);

  const isDisabled = useCallback(() => {
    for (const container of manifestation.containers) {
      for (const component of manifestation.components) {
        const video = component.componentType?.includes("video") && component.trackReference?.containerId === container.containerId;
        if (video) {
          if (environment === "uat" && !container["path"].includes(environment)) {
            if (!container["path"].includes("sit")) {
              return true;
            }
          } else {
            if (!container["path"].includes(environment)) {
              return true;
            }
          }
        }
      }
    }
    return false;
  }, [manifestation.components, manifestation.containers, environment]);

  const isPathInvalid = (path) => {
    if (environment === "uat" && !path.includes(environment)) {
      if (!path.includes("sit")) {
        return true;
      }
    } else {
      if (!path.includes(environment)) {
        return true;
      }
    }
    return false;
  };

  const handleChange = (file) => (e) => {
    handleSelectFile(e, file, "Video", manifestation, assetTitle, editRate, entityType, idType);
  };

  const getVideoAccordionDetails = (components, containers) =>
    containers?.map((container) => {
      if (container.path) {
        const pathSplit = container.path?.split(".");
        const format = pathSplit[pathSplit.length - 1];
        const file = `${container.containerId}.${format}`;
        return (
          <>
            {components?.map(
              (component) =>
                component.componentType?.includes("video") &&
                component.trackReference?.containerId ===
                  container.containerId && (
                  <>
                    {(idType === "dmi" || idType === "cantemo" || idType === "bim") && <Divider />}
                    <div className={(idType === "dmi" || idType === "cantemo" || idType === "bim") ? "mt-10" : ""} key={`video-container-${file}`}>
                      <span>
                        <Checkbox
                          className="pt-6"
                          onChange={handleChange(file)}
                          checked={selectedFiles[file]?.isChecked || false}
                          disabled={isPathInvalid(container["path"])}
                        />
                      </span>
                      <span className="font-bold word-break-all">{`${renamedFilename[file]}`}</span>
                    </div>
                    <Divider />
                    <div className={(idType === "dmi" || idType === "cantemo" || idType === "bim") ? "mt-10 mb-10" : "mt-10"} key={`video-container-path-${file}`}>
                      <span className="font-bold">{CREATE_MEDIA.pathLabel}</span>
                      <span className="word-break-all">{container.path}</span>
                    </div>
                    {(idType === "dmi" || idType === "cantemo" || idType === "bim") ? null : (
                      <List
                        className="media-desc-list"
                        key={`video-container-desc-${file}`}
                      >
                        <ListItem
                          className="media-desc-list-item"
                          key={`video-label-${file}`}
                        >
                          {CREATE_MEDIA.videoLabel}
                        </ListItem>
                        <ListItem className="media-desc-list-item" key="video-fps">
                          {getFrameRate(component)}
                        </ListItem>
                        <ListItem className="media-desc-list-item" key="video-codec">
                          {`Video Codec: ${VIDEO_CODEC[component.attributes?.videoCodec] || "-"}`}
                        </ListItem>
                        <ListItem className="media-desc-list-item" key="frame-size">
                          {`Frame Size: ${component.frameSizeCalculated || getAspectRatio(component.attributes?.frameSize?.width, component.attributes?.frameSize?.height) || "-"}`}
                        </ListItem>
                        <ListItem className="media-desc-list-item" key="active-picture">
                          {`Active Picture: ${component.activePictureCalculated || "-"}`}
                        </ListItem>
                        <ListItem className="media-desc-list-item" key="picture-aspect-ratio">
                          {`Picture Aspect Ratio: ${component.attributes?.pictureAspectRatio || "-"}`}
                        </ListItem>
                        <ListItem className="media-desc-list-item" key="resolution">
                          {`Resolution: ${component.attributes?.frameSize?.width}x${component.attributes?.frameSize?.height}`}
                        </ListItem>
                        {getAudioDetails(components, container.containerId)}
                      </List>
                    )}
                  </>
                )
            )}
          </>
        );
      }
      return null;
    });

  const getAudioDetails = (components, containerId) =>
    components?.map((component) => {
      const size = component.channels?.length;
      const audioContentKind =
        AUDIO_CONTENT_KIND_MAPPING[component.audioContentKind] || "Unknown";
      const language = component.spokenLanguage || "Unknown";
      const audioDescription = size
        ? `Audio ${size} CH (${audioContentKind}, ${language})`
        : `Audio (${audioContentKind}, ${language})`;
      return (
        <>
          {component.componentType?.includes("audio") &&
            component.channels?.[0]?.trackReference?.containerId ===
              containerId && (
              <ListItem
                className="media-desc-list-item"
                key={`audio-description-${containerId}`}
              >
                {audioDescription}
              </ListItem>
            )}
        </>
      );
    });

  const getExpandedAccordionInfo = () => {
    const idAccStructure = { ...idAccordionExpanded };
    const titleAccStructure = { ...titleAccordionExpanded };
    Object.keys(validAssets).forEach((validAssetsKey) => {
      idAccStructure[validAssetsKey] = true;
      titleAccStructure[validAssetsKey] = true;
    });
    _setTitleAccordionExpanded(titleAccStructure);
    _setIdAccordionExpanded(idAccStructure);
  };

  useEffect(() => {
    manifestation.containers?.forEach((container) => {
      if (container.path) {
        const pathSplit = container.path?.split(".");
        const format = pathSplit[pathSplit.length - 1];
        const file = `${container.containerId}.${format}`;
        manifestation.components?.forEach((component) => {
          const video =
            component.componentType?.includes("video") &&
            component.trackReference?.containerId === container.containerId;
          if (video && file in selectedFiles && selectedFiles[file]["isChecked"]) {
            getExpandedAccordionInfo();
            setExpanded(true);
          }
        });
      }
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [manifestation.components, manifestation.containers]);

  return (
    <>
      {totalVideosAvailable === 0 && null}
      {totalVideosAvailable > 0 && (
        <Accordion
          classes={{
            expanded: "media-accordion",
          }}
          className="media-assets-accordion"
          variant="outlined"
          expanded={expanded}
          onChange={(e, expanded) => {
            setExpanded(expanded);
          }}
        >
          <AccordionSummary
            className="media-asset-container-accordion-summary"
            expandIcon={<ExpandMoreIcon />}
            IconButtonProps={{ style: { color: "white" } }}
          >
            {CREATE_MEDIA.videoLabel}
          </AccordionSummary>
          <AccordionDetails className="media-asset-accordion-details">
            {(idType === "dmi" || idType === "cantemo" || idType === "bim") ? (
              <div>
                <span>
                  <Checkbox
                    className="pt-6"
                    onChange={(e) => handleSelectAllFile(e)}
                    checked={areAllCheckboxesChecked() || false}
                    disabled={isDisabled() || false}
                  />
                </span>
                <span>{CREATE_MEDIA.selectAllVideoLabel}</span>
              </div>
            ) : null}
            {getVideoAccordionDetails(
              manifestation?.components,
              manifestation?.containers
            )}
          </AccordionDetails>
        </Accordion>
      )}
    </>
  );
};

Video.defaultProps = {
  manifestation: {},
  assetTitle: "",
  entityType: "",
  idType: null,
};

export default Video;
